module.exports = __webpack_public_path__ + "static/media/upi.b7ab63af.svg";